<template>
  <div style="padding-bottom: 150px" class="centered">
    <div class="center" style="">
      <div class="header-title">
        <p class="title_">Todos os colaboradores desta filial</p>
        <el-input
          style="width: 300px; margin-right: 130px"
          v-model="search"
          size="medium"
          placeholder="Fazer busca"
          clearable
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
      <div class="table-teste" v-if="finshedLoad && dataTable.length > 0">
        <el-table
          :highlight-current-row="true"
          :cell-style="{ cursor: 'pointer' }"
          :header-cell-style="{ color: '#333' }"
          :default-sort="{ prop: 'name', order: 'descending' }"
          @sort-change="handleSort"
          @row-click="handleRowClick"
          :data="handleSearch"
          style="width: 100%"
        >
          <el-table-column
            label="Matrícula"
            prop="registration"
            sortable="custom"
          />
          <el-table-column label="Colaborador" prop="name" sortable="custom" />
          <el-table-column label="Área" prop="area" sortable="custom" />
          <el-table-column label="Perfil" prop="office" sortable="custom" />
          <el-table-column
            label="Custo total"
            width="180"
            prop="total_cost"
            sortable="custom"
          >
          </el-table-column>
        </el-table>
        <div class="pagination">
          <Paginator
            :pageSize="pageSize"
            :total="dataTableTemp.length"
            :start="(page - 1) * pageSize + 1"
            :end="
              page * pageSize > dataTableTemp.length
                ? dataTableTemp.length
                : (page - 1) * pageSize + pageSize
            "
            @set-page-size="setCurrentPageSize"
          />
          <el-pagination
            :hide-on-single-page="true"
            layout="prev, pager, next"
            :total="dataTableTemp.length"
            :page-size="pageSize"
            :current-page="page"
            @current-change="setPage"
          />
        </div>
      </div>
      <div style="font-size: 14px" v-else>
        <el-skeleton
          :rows="8"
          animated
          v-if="!finshedLoad"
          style="width: 90%"
        />
        {{
          dataTable.length === 0 && finshedLoad ? "Sem dados para exibir." : ""
        }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.el-button {
  background: #e87305;
  padding-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 8px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
}

.el-button:hover {
  background: #c76000;
  color: #fff;
}

.el-button:focus {
  background: #e87305;
  color: #fff;
}

.el-button:disabled {
  background: #e87305;
  opacity: 0.5;
}

.el-button:disabled:hover {
  background: #e87305;
  opacity: 0.5;
}

.icon-beaut {
  cursor: pointer;
  margin-right: 4px;
}

.icon-beaut:hover {
  color: #e87305;
}

.my-header {
  background: blue !important;
}

.confirm-items {
  display: flex;
  padding-top: 8px;
  padding-right: 15px !important;
}

.title_ {
  color: #515151;
  font-weight: bold;
}

.link-download {
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  color: rgb(0, 140, 202);
}

.link-download:hover {
  color: rgb(0, 140, 202);
  text-decoration: underline;
}

.btnFalses {
  background-color: #e87305 !important;
  border: none;
}

.btnFalses:hover {
  background-color: #d66800 !important;
  border: none;
}

.btnCancelFalses {
  background-color: #eaeaea !important;
  color: #515151 !important;
  border: none;
}

.right-position {
  display: flex;
  margin-top: 20px;
}

.alert-class {
  padding-bottom: 20px;
}

.el-icon-close:hover {
  color: #e87305 !important;
}

.number.active {
  color: #e87305 !important;
}

.number:hover {
  color: #e87305 !important;
}

.el-icon:hover {
  color: #e87305 !important;
}

.btn-next:hover {
  color: #e87305 !important;
}

.btn-prev:hover {
  color: #e87305 !important;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../utils/store";
import api from "../utils/api";
import constants from "../utils/constants";

import Paginator from "../components/Paginator.vue";
import sortDataTable from "../utils/sortDataTable";

export default {
  name: "Collaborators",
  components: {
    Paginator,
  },
  data() {
    return {
      constants: constants,
      locationId: null,
      finshedLoad: false,
      page: 1,
      pageSize: 10,
      dataTable: [],
      dataTableTemp: [],
      search: "",
      searchColumns: ["name", "register", "office", "total_cost"],
    };
  },
  computed: {
    ...mapGetters(["getLocationId", "getCollaborators"]),
    pagedTableData() {
      const data = this.dataTableTemp.slice(
        this.pageSize * this.page - this.pageSize,
        this.pageSize * this.page
      );
      if (data.length === 0) {
        this.page = 1;
      }
      return data;
    },
    handleSearch() {
      if (this.search.length > 0) {
        this.dataTableTemp = this.dataTable.filter((item) => {
          for (let value of this.searchColumns) {
            if (
              String(item[value])
                .toLowerCase()
                .includes(this.search.toLowerCase())
            )
              return item;
          }
        });
      } else {
        this.dataTableTemp = this.dataTable;
      }
      return this.pagedTableData;
    },
  },
  async created() {
    this.updateNavCurrentIndex("3");
    this.finshedLoad = false;
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route === "/apportionmentBylocation"
      ) {
        return { ...e, disabled: false, route: "/apportionmentBylocation" };
      } else {
        return { ...e, disabled: false };
      }
    });
    this.locationId = this.getLocationId;
    this.dataTable = (await this.getCollaborators) || [];
    this.updateNavItems_(array_teste);
    this.getCollaboratorsByRegion();
    this.dataTableTemp = this.dataTable;
  },
  watch: {
    getLocationId: function (val) {
      this.locationId = val;
    },
    getCollaborators: function (val) {
      this.dataTable = val;
      this.finshedLoad = true;
      this.dataTable = val.map((elem) => {
        return {
          ...elem,
          total_cost: elem.total_cost.toLocaleString(this.constants.language, {
            style: "currency",
            currency: this.constants.currency,
          }),
        };
      });
    },
  },
  methods: {
    ...mapActions([
      "updateNavItems",
      "updateNavCurrentIndex",
      "updateCollaborators",
    ]),
    async getCollaboratorsByRegion() {
      const { data } = await api.get("/findAllCollaborators", {
        params: { locale: this.locationId },
      });
      this.updateCollaborators(data);
      this.finshedLoad = true;
    },
    setPage(val) {
      this.page = val;
    },
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    handleRowClick(row) {
      this.$router.push({
        name: "apportionmentByCollaborator",
        params: { id: row.id },
      });
    },
    setCurrentPageSize(pageSize) {
      this.pageSize = pageSize.size;
    },
    handleSort(column) {
      this.dataTable = sortDataTable(this.dataTable, column);
    },
  },
};
</script>
